export default {"src":"/_next/static/media/search-background.6ed8c4d1.svg","height":126,"width":120,"blurWidth":0,"blurHeight":0};